<button
  type="button"
  class="eraser-options"
  (click)="toggleTooltip()"
  [disabled]="!isCanvasDirty || isOffline || isZoomed"
  [class.cursorDefault]="isOffline || isZoomed"
>
  <txtb-icons
    type="bigEraser"
    [fill]="!isCanvasDirty ? clearCanvasColor : activeFill || (tooltip ? activeColor : null)"
  ></txtb-icons>
</button>
<ul class="tooltip" *ngIf="tooltip && !isOffline && !isZoomed">
  <li class="eraser-option eraser" (click)="sendToolToggle()">
    <txtb-icons type="mediumEraser"></txtb-icons>
  </li>
  <li class="eraser-option clear all" (click)="clear()">
    <txtb-icons type="clearAll"></txtb-icons>
  </li>
</ul>
